/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppCatalogRouteImport } from './routes/_app/catalog'
import { Route as AppCustomersRouteImport } from './routes/_app/customers'
import { Route as AppHelpRouteImport } from './routes/_app/help'
import { Route as AppRfqsRouteImport } from './routes/_app/rfqs'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppSupportRouteImport } from './routes/_app/support'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthSetPasswordRouteImport } from './routes/_auth/set-password'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AcceptInvitationIdRouteImport } from './routes/accept-invitation.$id'
import { Route as ImpersonateTicketRouteImport } from './routes/impersonate.$ticket'
import { Route as QTokenRouteImport } from './routes/q.$token'
import { Route as RTokenRouteImport } from './routes/r.$token'
import { Route as AppHelpIndexRouteImport } from './routes/_app/help/index'
import { Route as AppHelpSlugRouteImport } from './routes/_app/help/$slug'
import { Route as AppHelpAskRouteImport } from './routes/_app/help/ask'
import { Route as AppHelpContactRouteImport } from './routes/_app/help/contact'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppQuotesIndexRouteImport } from './routes/_app/quotes/index'
import { Route as AppQuotesIdRouteImport } from './routes/_app/quotes/$id'
import { Route as AppRfqsIndexRouteImport } from './routes/_app/rfqs/index'
import { Route as AppRfqsIdRouteImport } from './routes/_app/rfqs/$id'
import { Route as AppRfqsNewRouteImport } from './routes/_app/rfqs/new'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsBillingRouteImport } from './routes/_app/settings/billing'
import { Route as AppSettingsStandardsRouteImport } from './routes/_app/settings/standards'
import { Route as AppSettingsTeamRouteImport } from './routes/_app/settings/team'
import { Route as AppSupportIndexRouteImport } from './routes/_app/support/index'
import { Route as AppSupportIdRouteImport } from './routes/_app/support/$id'
import { Route as AppProjectsIdIndexRouteImport } from './routes/_app/projects/$id/index'
import { Route as AppProjectsIdChangeOrdersCoIdRouteImport } from './routes/_app/projects/$id/change-orders.$coId'
import { Route as AppProjectsIdTakeoffsRunIdRouteImport } from './routes/_app/projects/$id/takeoffs.$runId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogRoute = AppCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersRoute = AppCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpRoute = AppHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AppRoute,
} as any)
const AppRfqsRoute = AppRfqsRouteImport.update({
  id: '/rfqs',
  path: '/rfqs',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportRoute = AppSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AppRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSetPasswordRoute = AuthSetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AcceptInvitationIdRoute = AcceptInvitationIdRouteImport.update({
  id: '/accept-invitation/$id',
  path: '/accept-invitation/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonateTicketRoute = ImpersonateTicketRouteImport.update({
  id: '/impersonate/$ticket',
  path: '/impersonate/$ticket',
  getParentRoute: () => rootRouteImport,
} as any)
const QTokenRoute = QTokenRouteImport.update({
  id: '/q/$token',
  path: '/q/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const RTokenRoute = RTokenRouteImport.update({
  id: '/r/$token',
  path: '/r/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppHelpIndexRoute = AppHelpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppHelpRoute,
} as any)
const AppHelpSlugRoute = AppHelpSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => AppHelpRoute,
} as any)
const AppHelpAskRoute = AppHelpAskRouteImport.update({
  id: '/ask',
  path: '/ask',
  getParentRoute: () => AppHelpRoute,
} as any)
const AppHelpContactRoute = AppHelpContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => AppHelpRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesIndexRoute = AppQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => AppRoute,
} as any)
const AppQuotesIdRoute = AppQuotesIdRouteImport.update({
  id: '/quotes/$id',
  path: '/quotes/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppRfqsIndexRoute = AppRfqsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRfqsRoute,
} as any)
const AppRfqsIdRoute = AppRfqsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppRfqsRoute,
} as any)
const AppRfqsNewRoute = AppRfqsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppRfqsRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsStandardsRoute = AppSettingsStandardsRouteImport.update({
  id: '/standards',
  path: '/standards',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTeamRoute = AppSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSupportIndexRoute = AppSupportIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSupportRoute,
} as any)
const AppSupportIdRoute = AppSupportIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppSupportRoute,
} as any)
const AppProjectsIdIndexRoute = AppProjectsIdIndexRouteImport.update({
  id: '/projects/$id/',
  path: '/projects/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIdChangeOrdersCoIdRoute =
  AppProjectsIdChangeOrdersCoIdRouteImport.update({
    id: '/projects/$id/change-orders/$coId',
    path: '/projects/$id/change-orders/$coId',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsIdTakeoffsRunIdRoute =
  AppProjectsIdTakeoffsRunIdRouteImport.update({
    id: '/projects/$id/takeoffs/$runId',
    path: '/projects/$id/takeoffs/$runId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/onboarding': typeof OnboardingRoute
  '/catalog': typeof AppCatalogRoute
  '/customers': typeof AppCustomersRoute
  '/help': typeof AppHelpRouteWithChildren
  '/rfqs': typeof AppRfqsRouteWithChildren
  '/settings': typeof AppSettingsRouteWithChildren
  '/support': typeof AppSupportRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/accept-invitation/$id': typeof AcceptInvitationIdRoute
  '/impersonate/$ticket': typeof ImpersonateTicketRoute
  '/q/$token': typeof QTokenRoute
  '/r/$token': typeof RTokenRoute
  '/help/$slug': typeof AppHelpSlugRoute
  '/help/ask': typeof AppHelpAskRoute
  '/help/contact': typeof AppHelpContactRoute
  '/quotes/$id': typeof AppQuotesIdRoute
  '/rfqs/$id': typeof AppRfqsIdRoute
  '/rfqs/new': typeof AppRfqsNewRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/standards': typeof AppSettingsStandardsRoute
  '/settings/team': typeof AppSettingsTeamRoute
  '/support/$id': typeof AppSupportIdRoute
  '/help/': typeof AppHelpIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/quotes/': typeof AppQuotesIndexRoute
  '/rfqs/': typeof AppRfqsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/support/': typeof AppSupportIndexRoute
  '/projects/$id/': typeof AppProjectsIdIndexRoute
  '/projects/$id/change-orders/$coId': typeof AppProjectsIdChangeOrdersCoIdRoute
  '/projects/$id/takeoffs/$runId': typeof AppProjectsIdTakeoffsRunIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/onboarding': typeof OnboardingRoute
  '/catalog': typeof AppCatalogRoute
  '/customers': typeof AppCustomersRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/accept-invitation/$id': typeof AcceptInvitationIdRoute
  '/impersonate/$ticket': typeof ImpersonateTicketRoute
  '/q/$token': typeof QTokenRoute
  '/r/$token': typeof RTokenRoute
  '/help/$slug': typeof AppHelpSlugRoute
  '/help/ask': typeof AppHelpAskRoute
  '/help/contact': typeof AppHelpContactRoute
  '/quotes/$id': typeof AppQuotesIdRoute
  '/rfqs/$id': typeof AppRfqsIdRoute
  '/rfqs/new': typeof AppRfqsNewRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/standards': typeof AppSettingsStandardsRoute
  '/settings/team': typeof AppSettingsTeamRoute
  '/support/$id': typeof AppSupportIdRoute
  '/help': typeof AppHelpIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/quotes': typeof AppQuotesIndexRoute
  '/rfqs': typeof AppRfqsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/support': typeof AppSupportIndexRoute
  '/projects/$id': typeof AppProjectsIdIndexRoute
  '/projects/$id/change-orders/$coId': typeof AppProjectsIdChangeOrdersCoIdRoute
  '/projects/$id/takeoffs/$runId': typeof AppProjectsIdTakeoffsRunIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/_app/catalog': typeof AppCatalogRoute
  '/_app/customers': typeof AppCustomersRoute
  '/_app/help': typeof AppHelpRouteWithChildren
  '/_app/rfqs': typeof AppRfqsRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/support': typeof AppSupportRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/set-password': typeof AuthSetPasswordRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/accept-invitation/$id': typeof AcceptInvitationIdRoute
  '/impersonate/$ticket': typeof ImpersonateTicketRoute
  '/q/$token': typeof QTokenRoute
  '/r/$token': typeof RTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/help/$slug': typeof AppHelpSlugRoute
  '/_app/help/ask': typeof AppHelpAskRoute
  '/_app/help/contact': typeof AppHelpContactRoute
  '/_app/quotes/$id': typeof AppQuotesIdRoute
  '/_app/rfqs/$id': typeof AppRfqsIdRoute
  '/_app/rfqs/new': typeof AppRfqsNewRoute
  '/_app/settings/billing': typeof AppSettingsBillingRoute
  '/_app/settings/standards': typeof AppSettingsStandardsRoute
  '/_app/settings/team': typeof AppSettingsTeamRoute
  '/_app/support/$id': typeof AppSupportIdRoute
  '/_app/help/': typeof AppHelpIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/quotes/': typeof AppQuotesIndexRoute
  '/_app/rfqs/': typeof AppRfqsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/support/': typeof AppSupportIndexRoute
  '/_app/projects/$id/': typeof AppProjectsIdIndexRoute
  '/_app/projects/$id/change-orders/$coId': typeof AppProjectsIdChangeOrdersCoIdRoute
  '/_app/projects/$id/takeoffs/$runId': typeof AppProjectsIdTakeoffsRunIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/catalog'
    | '/customers'
    | '/help'
    | '/rfqs'
    | '/settings'
    | '/support'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/set-password'
    | '/signup'
    | '/accept-invitation/$id'
    | '/impersonate/$ticket'
    | '/q/$token'
    | '/r/$token'
    | '/help/$slug'
    | '/help/ask'
    | '/help/contact'
    | '/quotes/$id'
    | '/rfqs/$id'
    | '/rfqs/new'
    | '/settings/billing'
    | '/settings/standards'
    | '/settings/team'
    | '/support/$id'
    | '/help/'
    | '/projects/'
    | '/quotes/'
    | '/rfqs/'
    | '/settings/'
    | '/support/'
    | '/projects/$id/'
    | '/projects/$id/change-orders/$coId'
    | '/projects/$id/takeoffs/$runId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/catalog'
    | '/customers'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/set-password'
    | '/signup'
    | '/accept-invitation/$id'
    | '/impersonate/$ticket'
    | '/q/$token'
    | '/r/$token'
    | '/help/$slug'
    | '/help/ask'
    | '/help/contact'
    | '/quotes/$id'
    | '/rfqs/$id'
    | '/rfqs/new'
    | '/settings/billing'
    | '/settings/standards'
    | '/settings/team'
    | '/support/$id'
    | '/help'
    | '/projects'
    | '/quotes'
    | '/rfqs'
    | '/settings'
    | '/support'
    | '/projects/$id'
    | '/projects/$id/change-orders/$coId'
    | '/projects/$id/takeoffs/$runId'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/onboarding'
    | '/_app/catalog'
    | '/_app/customers'
    | '/_app/help'
    | '/_app/rfqs'
    | '/_app/settings'
    | '/_app/support'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_auth/set-password'
    | '/_auth/signup'
    | '/accept-invitation/$id'
    | '/impersonate/$ticket'
    | '/q/$token'
    | '/r/$token'
    | '/_app/'
    | '/_app/help/$slug'
    | '/_app/help/ask'
    | '/_app/help/contact'
    | '/_app/quotes/$id'
    | '/_app/rfqs/$id'
    | '/_app/rfqs/new'
    | '/_app/settings/billing'
    | '/_app/settings/standards'
    | '/_app/settings/team'
    | '/_app/support/$id'
    | '/_app/help/'
    | '/_app/projects/'
    | '/_app/quotes/'
    | '/_app/rfqs/'
    | '/_app/settings/'
    | '/_app/support/'
    | '/_app/projects/$id/'
    | '/_app/projects/$id/change-orders/$coId'
    | '/_app/projects/$id/takeoffs/$runId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  OnboardingRoute: typeof OnboardingRoute
  AcceptInvitationIdRoute: typeof AcceptInvitationIdRoute
  ImpersonateTicketRoute: typeof ImpersonateTicketRoute
  QTokenRoute: typeof QTokenRoute
  RTokenRoute: typeof RTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalog': {
      id: '/_app/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof AppCatalogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers': {
      id: '/_app/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AppCustomersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help': {
      id: '/_app/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AppHelpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rfqs': {
      id: '/_app/rfqs'
      path: '/rfqs'
      fullPath: '/rfqs'
      preLoaderRoute: typeof AppRfqsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support': {
      id: '/_app/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AppSupportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/set-password': {
      id: '/_auth/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof AuthSetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/accept-invitation/$id': {
      id: '/accept-invitation/$id'
      path: '/accept-invitation/$id'
      fullPath: '/accept-invitation/$id'
      preLoaderRoute: typeof AcceptInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonate/$ticket': {
      id: '/impersonate/$ticket'
      path: '/impersonate/$ticket'
      fullPath: '/impersonate/$ticket'
      preLoaderRoute: typeof ImpersonateTicketRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/q/$token': {
      id: '/q/$token'
      path: '/q/$token'
      fullPath: '/q/$token'
      preLoaderRoute: typeof QTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$token': {
      id: '/r/$token'
      path: '/r/$token'
      fullPath: '/r/$token'
      preLoaderRoute: typeof RTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/help/': {
      id: '/_app/help/'
      path: '/'
      fullPath: '/help/'
      preLoaderRoute: typeof AppHelpIndexRouteImport
      parentRoute: typeof AppHelpRoute
    }
    '/_app/help/$slug': {
      id: '/_app/help/$slug'
      path: '/$slug'
      fullPath: '/help/$slug'
      preLoaderRoute: typeof AppHelpSlugRouteImport
      parentRoute: typeof AppHelpRoute
    }
    '/_app/help/ask': {
      id: '/_app/help/ask'
      path: '/ask'
      fullPath: '/help/ask'
      preLoaderRoute: typeof AppHelpAskRouteImport
      parentRoute: typeof AppHelpRoute
    }
    '/_app/help/contact': {
      id: '/_app/help/contact'
      path: '/contact'
      fullPath: '/help/contact'
      preLoaderRoute: typeof AppHelpContactRouteImport
      parentRoute: typeof AppHelpRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/': {
      id: '/_app/quotes/'
      path: '/quotes'
      fullPath: '/quotes/'
      preLoaderRoute: typeof AppQuotesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quotes/$id': {
      id: '/_app/quotes/$id'
      path: '/quotes/$id'
      fullPath: '/quotes/$id'
      preLoaderRoute: typeof AppQuotesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rfqs/': {
      id: '/_app/rfqs/'
      path: '/'
      fullPath: '/rfqs/'
      preLoaderRoute: typeof AppRfqsIndexRouteImport
      parentRoute: typeof AppRfqsRoute
    }
    '/_app/rfqs/$id': {
      id: '/_app/rfqs/$id'
      path: '/$id'
      fullPath: '/rfqs/$id'
      preLoaderRoute: typeof AppRfqsIdRouteImport
      parentRoute: typeof AppRfqsRoute
    }
    '/_app/rfqs/new': {
      id: '/_app/rfqs/new'
      path: '/new'
      fullPath: '/rfqs/new'
      preLoaderRoute: typeof AppRfqsNewRouteImport
      parentRoute: typeof AppRfqsRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/billing': {
      id: '/_app/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/standards': {
      id: '/_app/settings/standards'
      path: '/standards'
      fullPath: '/settings/standards'
      preLoaderRoute: typeof AppSettingsStandardsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/team': {
      id: '/_app/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AppSettingsTeamRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/support/': {
      id: '/_app/support/'
      path: '/'
      fullPath: '/support/'
      preLoaderRoute: typeof AppSupportIndexRouteImport
      parentRoute: typeof AppSupportRoute
    }
    '/_app/support/$id': {
      id: '/_app/support/$id'
      path: '/$id'
      fullPath: '/support/$id'
      preLoaderRoute: typeof AppSupportIdRouteImport
      parentRoute: typeof AppSupportRoute
    }
    '/_app/projects/$id/': {
      id: '/_app/projects/$id/'
      path: '/projects/$id'
      fullPath: '/projects/$id/'
      preLoaderRoute: typeof AppProjectsIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$id/change-orders/$coId': {
      id: '/_app/projects/$id/change-orders/$coId'
      path: '/projects/$id/change-orders/$coId'
      fullPath: '/projects/$id/change-orders/$coId'
      preLoaderRoute: typeof AppProjectsIdChangeOrdersCoIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$id/takeoffs/$runId': {
      id: '/_app/projects/$id/takeoffs/$runId'
      path: '/projects/$id/takeoffs/$runId'
      fullPath: '/projects/$id/takeoffs/$runId'
      preLoaderRoute: typeof AppProjectsIdTakeoffsRunIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppHelpRouteChildren {
  AppHelpSlugRoute: typeof AppHelpSlugRoute
  AppHelpAskRoute: typeof AppHelpAskRoute
  AppHelpContactRoute: typeof AppHelpContactRoute
  AppHelpIndexRoute: typeof AppHelpIndexRoute
}

const AppHelpRouteChildren: AppHelpRouteChildren = {
  AppHelpSlugRoute: AppHelpSlugRoute,
  AppHelpAskRoute: AppHelpAskRoute,
  AppHelpContactRoute: AppHelpContactRoute,
  AppHelpIndexRoute: AppHelpIndexRoute,
}

const AppHelpRouteWithChildren =
  AppHelpRoute._addFileChildren(AppHelpRouteChildren)

interface AppRfqsRouteChildren {
  AppRfqsIdRoute: typeof AppRfqsIdRoute
  AppRfqsNewRoute: typeof AppRfqsNewRoute
  AppRfqsIndexRoute: typeof AppRfqsIndexRoute
}

const AppRfqsRouteChildren: AppRfqsRouteChildren = {
  AppRfqsIdRoute: AppRfqsIdRoute,
  AppRfqsNewRoute: AppRfqsNewRoute,
  AppRfqsIndexRoute: AppRfqsIndexRoute,
}

const AppRfqsRouteWithChildren =
  AppRfqsRoute._addFileChildren(AppRfqsRouteChildren)

interface AppSettingsRouteChildren {
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSettingsStandardsRoute: typeof AppSettingsStandardsRoute
  AppSettingsTeamRoute: typeof AppSettingsTeamRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsStandardsRoute: AppSettingsStandardsRoute,
  AppSettingsTeamRoute: AppSettingsTeamRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppSupportRouteChildren {
  AppSupportIdRoute: typeof AppSupportIdRoute
  AppSupportIndexRoute: typeof AppSupportIndexRoute
}

const AppSupportRouteChildren: AppSupportRouteChildren = {
  AppSupportIdRoute: AppSupportIdRoute,
  AppSupportIndexRoute: AppSupportIndexRoute,
}

const AppSupportRouteWithChildren = AppSupportRoute._addFileChildren(
  AppSupportRouteChildren,
)

interface AppRouteChildren {
  AppCatalogRoute: typeof AppCatalogRoute
  AppCustomersRoute: typeof AppCustomersRoute
  AppHelpRoute: typeof AppHelpRouteWithChildren
  AppRfqsRoute: typeof AppRfqsRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppSupportRoute: typeof AppSupportRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppQuotesIdRoute: typeof AppQuotesIdRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppQuotesIndexRoute: typeof AppQuotesIndexRoute
  AppProjectsIdIndexRoute: typeof AppProjectsIdIndexRoute
  AppProjectsIdChangeOrdersCoIdRoute: typeof AppProjectsIdChangeOrdersCoIdRoute
  AppProjectsIdTakeoffsRunIdRoute: typeof AppProjectsIdTakeoffsRunIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCatalogRoute: AppCatalogRoute,
  AppCustomersRoute: AppCustomersRoute,
  AppHelpRoute: AppHelpRouteWithChildren,
  AppRfqsRoute: AppRfqsRouteWithChildren,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppSupportRoute: AppSupportRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppQuotesIdRoute: AppQuotesIdRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppQuotesIndexRoute: AppQuotesIndexRoute,
  AppProjectsIdIndexRoute: AppProjectsIdIndexRoute,
  AppProjectsIdChangeOrdersCoIdRoute: AppProjectsIdChangeOrdersCoIdRoute,
  AppProjectsIdTakeoffsRunIdRoute: AppProjectsIdTakeoffsRunIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSetPasswordRoute: typeof AuthSetPasswordRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSetPasswordRoute: AuthSetPasswordRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
  AcceptInvitationIdRoute: AcceptInvitationIdRoute,
  ImpersonateTicketRoute: ImpersonateTicketRoute,
  QTokenRoute: QTokenRoute,
  RTokenRoute: RTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
